import {
  AuthVerifyOtpBodyType,
  AuthVerifyOtpResponseType
} from "@website/widget/login/services/auth-b2b-verify-otp/auth-b2b-verify-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const AuthVerifyOtpUrl = `${BASE_URL_PROFILE}/b2b/auth/otp`;

export const AuthB2BVerifyOtpService = (
  body: AuthVerifyOtpBodyType
): Promise<AuthVerifyOtpResponseType> =>
  Axios.post(AuthVerifyOtpUrl, body).then(
    ({ data }: AxiosResponse<AuthVerifyOtpResponseType>) => data
  );
